import {
	GetOdontoAvailableTimes,
	GetOdontoAvailableTimesParams,
	GetOdontoAvailableTimesModel,
} from 'domain/usecases';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteGetOdontoAvailableTimes implements GetOdontoAvailableTimes {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetOdontoAvailableTimesModel>,
	) {}

	async get({
		signal,
		...params
	}: GetOdontoAvailableTimesParams): Promise<GetOdontoAvailableTimesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
